import React from 'react'
import { formatOrderStatusLabel } from '@@partner:helpers/formatters/order'

import { Tag } from 'rsuite'

export interface OrderStatusLabelProps {
  status: number
}

export default function OrderStatusLabel ({ status }: OrderStatusLabelProps) {
  const { label, color = null } = formatOrderStatusLabel(status)
  return (
    <Tag className="u-status-badge" color={color}>
      {label}
    </Tag>
  )
}
